import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';

import styles from './Encoding.css';
import icon from './encoding.svg';

class Encoding extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <img className={styles.image} src={icon} alt="encoding" />
        <span className={styles.titleSpinnerWrapper}>
          <p className={styles.title}>
            <FormattedMessage id="VIDEO_ENCODING_HEADLINE" />
          </p>
          <span className={styles.spinnerWrapper}>
            <DotLoadingIndicator />
          </span>
        </span>
        <p className={styles.description}>
          <FormattedMessage id="VIDEO_ENCODING_MESSAGE" />
        </p>
      </div>
    );
  }
}

export default Encoding;
